import {IStateService} from 'angular-ui-router';
import AuthServiceRS from '../../../authentication/service/AuthServiceRS.rest';
import {BemerkungDialogController} from '../../../core/dialog/BemerkungDialogController';
import {OkCancelController} from '../../../core/dialog/OkCancelController';
import {RemoveDialogController} from '../../../core/dialog/RemoveDialogController';
import {DvDialog} from '../../../core/directive/dv-dialog/dv-dialog';
import ErrorService from '../../../core/errors/service/ErrorService';
import BeitragRS from '../../../core/service/BeitragRS';
import RoleUtilService from '../../../core/service/RoleUtilService';
/*
 * Copyright © 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschützt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulässig. Dies gilt
 * insbesondere für Vervielfältigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht übergeben, ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 */
import SchadenfallModelManager from '../../../core/service/SchadenfallModelManager';
import StatuswechselService from '../../../core/service/StatuswechselService';
import {TSBegruendungsCode} from '../../../models/enums/TSBegruendungsCode';
import {TSBeitragStatus} from '../../../models/enums/TSBeitragStatus';
import {TSBemerkungScope} from '../../../models/enums/TSBemerkungScope';
import {TSSchadenfallEvent} from '../../../models/enums/TSSchadenfallEvent';
import {TSSchadenfallStatus} from '../../../models/enums/TSSchadenfallStatus';
import TSBeitrag from '../../../models/TSBeitrag';
import TSSchadenfall from '../../../models/TSSchadenfall';
import TSStatuswechsel from '../../../models/TSStatuswechsel';
import DVBernUtil from '../../../utils/DVBernUtil';
import {IBeitragStateParams} from '../../gesuch.route';
import AbstractModelManagerController from '../abstractModelManagerController';

declare let require: any;
declare let angular: any;

import IComponentOptions = angular.IComponentOptions;
import IFormController = angular.IFormController;
import ILogService = angular.ILogService;
import IQService = angular.IQService;
import IScope = angular.IScope;
import ITranslateService = angular.translate.ITranslateService;

let styles = require('./entschaedigungView.scss');
let template = require('./entschaedigungView.html');
let removeDialogTemplate = require('../../../core/dialog/removeDialogTemplate.html');
let bemerkungDialogTemplate = require('../../../core/dialog/bemerkungDialogTemplate.html');
let okCancelTemplate = require('../../../core/dialog/okCancelTemplate.html');

export class EntschaedigungViewComponentConfig implements IComponentOptions {
    transclude: boolean = false;
    template: string = template;
    controller: any = EntschaedigungViewController;
    controllerAs: string = 'vm';
    bindings: any = {
        schadenfall: '<'
    };
}

export class EntschaedigungViewController extends AbstractModelManagerController<TSSchadenfall> {
    static $inject = ['DVBernUtil', 'SchadenfallModelManager', '$q', '$scope', '$translate', '$log', '$state',
        'DvDialog', 'BeitragRS', 'RoleUtilService', 'StatuswechselService', 'AuthServiceRS', 'ErrorService'];
    schadenfall: TSSchadenfall;
    form: IFormController;
    ermittelterSchadenForm: IFormController;
    isErmittelterSchadenSet: boolean;

    statuswechsel: TSStatuswechsel | undefined;
    checklistValid: boolean;
    schadenfallEvent: TSSchadenfallEvent | undefined;

    /* @ngInject */
    constructor(private dvBernUtil: DVBernUtil, schadenfallModelManager: SchadenfallModelManager,
                private  $q: IQService,
                $scope: IScope, private $translate: ITranslateService, private $log: ILogService,
                private $state: IStateService, private dvDialog: DvDialog, private beitragRS: BeitragRS,
                public roleUtilService: RoleUtilService, private statuswechselService: StatuswechselService,
                private authServiceRS: AuthServiceRS, private errorService: ErrorService) {
        super(schadenfallModelManager, $scope, $state.current.name);

    }

    $onInit() {
        super.$onInit();
        if (!this.schadenfall.beitraege) {
            this.schadenfall.beitraege = [];
        }

        if (!this.schadenfall) {
            this.$log.error('no schadenfall passed to view');
        } else {
            this.initialModel = this.schadenfall;
            this.model = angular.copy(this.schadenfall);
            this.isErmittelterSchadenSet = this.model.ermittelterSchaden !== 0;
        }
        this.statuswechsel = this.statuswechselService.getStatuswechselMetadata(this.schadenfall.status, this.schadenfall.erfassungsart);

    }

    public getSchadenName(index: string): string {
        return this.$translate.instant('SCHADEN') + ' ' + index;

    }

    private resetView() {
        this.form.$setPristine();
        this.form.$setUntouched();

    }

    public addBeitrag() {
        let newBeitrag = new TSBeitrag();
        let params: IBeitragStateParams;
        params = {
            schadenfall: this.schadenfall,
            beitrag: newBeitrag,
            schadenfallId: this.schadenfall.id,
            beitragId: undefined
        };
        this.$state.go('beitrag', params);
    }

    public hasBeitraege(): boolean {
        if (this.schadenfall && this.schadenfall.beitraege && this.schadenfall.beitraege.length > 0) {
            return true;
        }
        return false;
    }

    public deleteBeitrag(beitrag: TSBeitrag, event: any): void {

        this.dvDialog.showDialog(removeDialogTemplate, RemoveDialogController, {
            text: '',
            title: 'BEITRAG_LOESCHEN'
        }).then(() => {   //User confirmed removal
            this.schadenfallModelManager.removeBeitrag(beitrag);
        }).catch(() => {
        });

    }

    public getTotal(): number {
        let val: number = 0;
        this.schadenfall.beitraege.forEach((beitrag) => {
            val += beitrag.beitrag;
        });
        return val;
    }

    public getViewTitle(): string {
        return this.dvBernUtil.getViewTitle(this.schadenfall);
    }

    public isFreigabeVisible(): boolean {
        //maybe extract this out into service?
        if (this.statuswechsel !== undefined) {
            let hasAllowedRole = this.authServiceRS.isOneOfRoles(this.statuswechsel.allowedRoles);
            let isOnRelevantPage = this.statuswechsel.visibleOnPage === this.$state.current.name;
            return hasAllowedRole && isOnRelevantPage && this.getSchadenfallEvents().length !== 0
        }
        return false;
    }

    public getChecklistEntries(): Array<string> {
        if (this.statuswechsel !== undefined) {
            return this.statuswechsel.checklistOptions;
        }
        return [];
    }

    public getBegrundungscodeOptions(): Array<TSBegruendungsCode> {
        if (this.statuswechsel !== undefined) {
            if (this.schadenfallEvent === undefined) {
                console.warn('Should have selected schadenfallEvent to trigger, otherwise allowed begruendugnscodes will not be set)');
                return [];
            } else {
                return this.statuswechsel.readBegruendungscodeOptions(this.schadenfallEvent);
            }
        }
        return [];
    }

    public getSchadenfallEvents() {
        if (this.statuswechsel !== undefined) {
            return this.statuswechsel.possibleEvents;
        }
        return [];
    }

    public checklistStatusChanged(allchecked: boolean): void {
        this.checklistValid = allchecked;
        if (!this.checklistValid) {
            this.schadenfallEvent = undefined;
        }
    }

    public isFreigabeDisabled(): boolean {
        return this.checklistValid !== true;
    }

    private next() {
        this.errorService.clearAll();
        if (this.schadenfall.status === TSSchadenfallStatus.SCHADEN_BEHOBEN_ABRECHNEN) {
            if (this.schadenfall.hasBeitrag() ||
                (!this.schadenfall.hasBeitrag() && this.eventIsRueckweisung())) {
                this.triggerGenericFreigabeDialog();
            } else {
                this.errorService.addMesageAsError('ERROR_NO_BEITRAG');
            }

        } else {
            this.$log.info('no next state available for this fall in this role');
        }

    }

    private eventIsRueckweisung() {
        return (this.schadenfallEvent === TSSchadenfallEvent.ABRECHNUNG_MANGELHAFT ||
            this.schadenfallEvent === TSSchadenfallEvent.ABLEHNUNG);
    }

    private triggerGenericFreigabeDialog() {
        this.dvDialog.showBemerkungDialog(bemerkungDialogTemplate, BemerkungDialogController, {
            text: this.schadenfallEvent,
            begrundungscodeOptions: this.getBegrundungscodeOptions(),
            showBegruendung: true,
            showBemerkung: true
        }).then((response) => {
            if (response && this.schadenfallEvent) {
                //todo team mit duncan anschauen wo die bemerkung hin soll
                this.schadenfallModelManager.handleTransition(this.schadenfall, TSBemerkungScope.AUFWAENDE, response.begruendung,
                    response.bemerkung, this.schadenfallEvent)
                    .then((response) => {
                        //todo wohin denn?
                        this.$state.go('schadenfaelle');
                    });
            }
        }).catch(() => {
        });
    }

    editClicked(beitragToView: any, event: any) {
        let params: IBeitragStateParams;
        params = {
            schadenfall: this.schadenfall,
            beitrag: beitragToView,
            schadenfallId: this.schadenfall.id,
            beitragId: beitragToView.id
        };
        this.$state.go('beitrag', params);

    }

    public isAusgefuehrt(beitrag: TSBeitrag): boolean {
        return beitrag.beitragStatus === TSBeitragStatus.AUSGEFUEHRT;
    }

    public cannotAddBeitraege(): boolean {
        return this.isSchadenFallReadonly()
            || !this.isErmittelterSchadenSet
            || this.ermittelterSchadenForm.$invalid
            || this.ermittelterSchadenForm.$dirty;
    }

    public saveErmittelterSchaden(): void {
        this.errorService.clearAll();
        if (this.ermittelterSchadenForm.$valid && this.model) {
            if (this.model.hasBeitrag() &&
                (this.model.nichtBerechtigterAnteil !== this.initialModel.nichtBerechtigterAnteil ||
                 this.model.ermittelterSchaden !== this.initialModel.nichtBerechtigterAnteil)) {
                this.dvDialog.showDialog(okCancelTemplate, OkCancelController, {
                    title: 'ERMITTELTER_SCHADEN',
                    text: 'ERMITTELTER_SCHADEN_CHANGED_TEXT'
                }).then(() => {
                    // TODO dase
                    // Vielleicht könnte man hier die Beiträge automatisch aktualisieren.
                });
            }
            this.schadenfallModelManager.saveSchadenfall(this.model).then((schadResp: TSSchadenfall) => {
                this.initialModel = schadResp;
                this.model = angular.copy(schadResp);
                this.schadenfall = schadResp;
                this.isErmittelterSchadenSet = this.model.ermittelterSchaden !== 0;
                this.ermittelterSchadenForm.$setPristine();
            });
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/gesuch/component/entschaedigungView/entschaedigungView.ts